import { Component, OnInit, inject } from '@angular/core';
import {FormControl, FormsModule, ReactiveFormsModule} from "@angular/forms";
import {LocaleService} from "../../../../locale/locale.service";
import {FormNavigationService} from "../../../../services/form-navigation/form-navigation.service";
import { NavigationKey } from '../../../../enums/navigation-key-type';
import {ClaimsService} from "../../../../services/claims.service";
import {FooterComponent} from "../../../common/footer/footer.component";
import {HeaderComponent} from "../../../common/header/header.component";


@Component({
  selector: 'app-police-preformed-drug-test',
  imports: [
    FooterComponent,
    FormsModule,
    HeaderComponent,
    ReactiveFormsModule
],
  templateUrl: './police-preformed-drug-test.component.html',
  styleUrl: './police-preformed-drug-test.component.css'
})
export class PolicePreformedDrugTestComponent implements OnInit {
  locale = inject(LocaleService);
  private formNavigationService = inject(FormNavigationService);
  private claimService = inject(ClaimsService);

  showError: boolean = false;
  options: { headline: string, caption: string, value: boolean }[] = [];
  radioControl = new FormControl();

  ngOnInit(): void {
    this.options = [
      {
        headline: this.locale.currentTranslation.yes,
        caption: '',
        value: true
      },
      {
        headline: this.locale.currentTranslation.no,
        caption: '',
        value: false
      }
    ];
    this.claimService.getData().subscribe(() => {
      if (this.claimService.claimReport()?.policeDrugTestPerformed !== null) {
        this.radioControl = new FormControl(this.claimService.claimReport().policeDrugTestPerformed);
      }
    })
  }

  nextClicked() {
    this.evaluateShowError()
    if (!this.showError) {
      this.claimService.updateClaimReport({policeDrugTestPerformed: this.radioControl.getRawValue()});
      this.claimService.save().subscribe(() => {
        this.formNavigationService.navigate(NavigationKey['police-drug-test']);
      });
    }
  }

  private evaluateShowError() {
    let rawValue = this.radioControl.getRawValue();
    this.showError = rawValue == null;
  }

  setOption(value: boolean) {
    this.radioControl.patchValue(value);
    this.showError = false
  }
}
